<template>
	<div class="content">
		<h3>经销批量新增</h3>
		<div class="item">
			<div class="btn">
				<el-button icon="el-icon-plus" type="primary" @click="AddWorkShop">添加</el-button>
				<el-button icon="el-icon-search" type="primary" @click="SelWorkShop">查询</el-button>
				<el-button type="primary">导出</el-button>
			</div>
			<el-form ref="form" style="width:auto" inline :model="form" label-width="80px">
				<el-form-item label="用户名">
					<el-input v-model="form.username"></el-input>
				</el-form-item>
				<el-form-item label="真实姓名">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column label="用户名"></el-table-column>
				<el-table-column label="真实姓名"></el-table-column>
				<el-table-column label="性别"></el-table-column>
				<el-table-column label="联系电话"></el-table-column>
				<el-table-column label="所属部门"></el-table-column>
				<el-table-column label="账号类型"></el-table-column>
				<el-table-column label="负责经销商"></el-table-column>
				<el-table-column label="启用状态"></el-table-column>
				<el-table-column label="操作">
					<template>
						<el-button type="text">添加</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form: {
				username: '',
				name: ''
			},
			tableData: []
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
</style>


// WEBPACK FOOTER //
// src/pages/settingAdd.vue